var map = {
	"./aia.svg": 2993,
	"./ant.svg": 2994,
	"./aus.svg": 2995,
	"./bah.svg": 2996,
	"./ban.svg": 2997,
	"./bar.svg": 2998,
	"./ber.svg": 2999,
	"./biz.svg": 3000,
	"./bot.svg": 3001,
	"./bru.svg": 3002,
	"./can.svg": 3003,
	"./cay.svg": 3004,
	"./cmr.svg": 3005,
	"./cok.svg": 3006,
	"./cyp.svg": 3007,
	"./dma.svg": 3008,
	"./eng.svg": 3009,
	"./fij.svg": 3010,
	"./flk.svg": 3011,
	"./gab.svg": 3012,
	"./gam.svg": 3013,
	"./ggy.svg": 3014,
	"./gha.svg": 3015,
	"./gib.svg": 3016,
	"./grn.svg": 3017,
	"./guy.svg": 3018,
	"./ind.svg": 3019,
	"./iom.svg": 3020,
	"./ivb.svg": 3021,
	"./jam.svg": 3022,
	"./jey.svg": 3023,
	"./ken.svg": 3024,
	"./kir.svg": 3025,
	"./lca.svg": 3026,
	"./les.svg": 3027,
	"./manifest.json": 863,
	"./mas.svg": 3028,
	"./maw.svg": 3029,
	"./mdv.svg": 3030,
	"./mlt.svg": 3031,
	"./moz.svg": 3032,
	"./mri.svg": 3033,
	"./msr.svg": 3034,
	"./nam.svg": 3035,
	"./nfk.svg": 3036,
	"./ngr.svg": 3037,
	"./nir.svg": 3038,
	"./niu.svg": 3039,
	"./nru.svg": 3040,
	"./nzl.svg": 3041,
	"./pak.svg": 3042,
	"./png.svg": 3043,
	"./rsa.svg": 3044,
	"./rwa.svg": 3045,
	"./sam.svg": 3046,
	"./sco.svg": 3047,
	"./sey.svg": 3048,
	"./sgp.svg": 3049,
	"./shn.svg": 3050,
	"./skn.svg": 3051,
	"./sle.svg": 3052,
	"./sol.svg": 3053,
	"./sri.svg": 3054,
	"./svg-country.svg": 3055,
	"./swz.svg": 3056,
	"./tan.svg": 3057,
	"./tca.svg": 3058,
	"./tga.svg": 3059,
	"./tog.svg": 3060,
	"./tto.svg": 3061,
	"./tuv.svg": 3062,
	"./uga.svg": 3063,
	"./van.svg": 3064,
	"./wal.svg": 3065,
	"./zam.svg": 3066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2992;